import { SceneBase } from '@jollywise/jollygoodgame';
import { KEYS } from 'game/constants/SceneConstants';
import { ButtonClimateChampions } from '../display/ui/ButtonClimateChampions';

export class Complete extends SceneBase {
  constructor() {
    super({ key: KEYS.Complete, active: false });
  }

  create() {
    super.create();

    this.game.hud.setState('COMPLETE');
    // this.game.trackView('complete');

    const btnContinue = new ButtonClimateChampions(this, {
      x: 840,
      y: 630,
      ariaLabelID: 'button_continue',
      id: 'btn_continue',
      costume: 'btn_continue',
      // vo: { sheet: 'gelvo', id: 'continue' },
    });
    btnContinue.once('click', this.handleContinueGame, this);
  }

  handleContinueGame() {
    this.game.showWelcome();
  }
}
